import { render } from "./SortingControls.vue?vue&type=template&id=13025832&scoped=true"
import script from "./SortingControls.vue?vue&type=script&lang=js"
export * from "./SortingControls.vue?vue&type=script&lang=js"

import "./SortingControls.vue?vue&type=style&index=0&id=13025832&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13025832"]])

export default __exports__